import { useState, useEffect } from 'react';
import Select from 'react-select';

function PackageDeliveryUserSelect(props) {
  const [selected, setSelected] = useState(null);

  // Set default value when props.defaultVal changes
  useEffect(() => {
    if (props?.defaultVal) {
      setSelected(props.defaultVal);
    } else {
      setSelected(null);
    }
  }, [props?.defaultVal]);

  const customOption = props?.list?.map(user => {
    return { ...user, label: `${user.name}`, value: user.user_id };
  });

  const customStyles = {
    control: base => ({
      ...base,
      height: 42,
      backgroundColor: '#ffffff',
      zIndex: 10,
    }),
    indicatorSeparator: styles => ({ ...styles, display: 'none' }),
    valueContainer: styles => ({
      ...styles,
      backgroundColor: '#ffffff',
      height: 20,
      paddingBottom: '45px',
      marginLeft: '13px',
    }),
    option: styles => ({ ...styles, backgroundColor: 'white', color: 'black' }),
    menuPortal: styles => ({ ...styles, zIndex: 40 }),
  };

  useEffect(() => {
    if (props?.cleared === true) {
      setSelected(null);
    }
  }, [props?.cleared]);

  return (
    <>
      <Select
        menuPlacement="auto"
        placeholder="Select one"
        menuPosition="fixed"
        value={selected}
        onChange={e => {
          setSelected(e);
          props?.onOptionSelect(e);
        }}
        options={customOption}
        styles={customStyles}
        isClearable
      />
    </>
  );
}

export default PackageDeliveryUserSelect;
